import Card from "../ui/Card";
import PropTypes from "prop-types";


import { useAgentStore } from "../../store/agentStore";


import { Pencil } from "lucide-react";

export default function LeadScoreCard({ onEdit, scoringConfig: scoringConfigProp }) {
  const { selectedAgent } = useAgentStore();
  const scoringConfig =  selectedAgent?.scoring_config || scoringConfigProp || {};

  if (Object.keys(scoringConfig).length === 0) {
    return <h3>Add Lead Scoring Configuration</h3>;
  }

  return (
    <Card className="property-card max-w-0 m-0 p-3 position-relative h-100">
      <div className="card-header">
        <h3>Lead Scores</h3>
      </div>
  
      <div className="property-actions">
        <button onClick={onEdit}>
          <Pencil size={18} className="text-slate-600" />
        </button>
      </div>

      <div className="grid-auto-fit">
        {Object.entries(scoringConfig)
          .filter(([key]) => key !== "agent_id" && key !== "id")
          .map(([key, value]) => (
            <div key={key} className="lead-score-item bg-gray-100 rounded-md">
              <div className="lead-score-header d-flex justify-between fw-medium text-primary">
              <span>
                {{
                  timeline_0_3: "Timeline 0-3 Months",
                  timeline_3_6: "Timeline 3-6 Months",
                  timeline_above_6: "Timeline Above 6 Months",
                }[key] ||
                  key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (c) => c.toUpperCase())}
              </span>

                <span className="lead-score-value fw-semibold">{value}</span>
              </div>

              <div className="lead-score-progress">
                <div
                  className="lead-score-progress-fill"
                  style={{ width: `${value * 10}%` }}
                />
              </div>
            </div>
          ))}
      </div>
    </Card>
  );
}

LeadScoreCard.propTypes = {
  onEdit: PropTypes.func.isRequired,
  scoringConfig: PropTypes.object,
  data: PropTypes.array,
};
